import { Stack } from 'expo-router'

export const unstable_settings = {
  // Ensure that reloading on `/modal` keeps a back button present.
  initialRouteName: 'index',
}

export default function ModalLayout() {
  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen name="index" />
      <Stack.Screen
        name="replies"
        options={{
          title: 'Replies',
        }}
      />
      <Stack.Screen
        name="edit"
        options={{
          presentation: 'modal',
          webModalStyle: {
            height: '90%',
            width: '95%',
          },
          headerShown: false,
          title: '',
        }}
      />
      <Stack.Screen
        name="upload"
        options={{
          presentation: 'modal',
          webModalStyle: {
            height: '90%',
            width: '95%',
          },
          title: 'Upload chat to school templates',
        }}
      />
      <Stack.Screen
        name="media-source"
        options={{
          presentation: 'modal',
          webModalStyle: {
            height: '90%',
            width: '95%',
          },
          headerShown: false,
          title: '',
        }}
      />
    </Stack>
  )
}
